import { User } from '../types';

export const RH_ROLES = ['rh', 'admin', 'dirigeant', 'manager'] as const;
export const COLLABORATEUR_ROLES = ['collaborateur', 'salarie'] as const;

export const isRhUser = (user: User | null): boolean =>
  !!user && RH_ROLES.includes(user.role as (typeof RH_ROLES)[number]);

export const isCollaborateurUser = (user: User | null): boolean =>
  !!user && COLLABORATEUR_ROLES.includes(user.role as (typeof COLLABORATEUR_ROLES)[number]);

export const getDefaultHomePath = (user: User | null): string => '/dashboard';

export const shouldSkipOnboarding = (user: User | null): boolean =>
  isCollaborateurUser(user);
